import React, { useContext, useEffect, useState } from 'react';
import { Button, Typography, MenuItem, Grid, Box, Card, TextField, FormControl, Select, Chip, Paper, IconButton, Modal, InputAdornment } from '@mui/material';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { formatDateTime } from '../../../utils/dateUtils';
import { Close, Edit } from '@mui/icons-material';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import ChangeMobileNumber from './ChangeMobileNumber';
import { PermissionGuard } from '../../../components/PermissionGuard';
import LocationHistory from './LocationHistory';
import AddressDetails from './AddressDetails';

export default function BasicDetails({ personalDetails, fetchData, customerVerificationModal, setCustomerVerificationModal }) {

  const [providerPersonalDetails, setProviderPersonalDetails] = useState(
    {
      firstName: '',
      middleName: '',
      lastName: '',
      email: '',
      dob: '',
      mobileNumber: '',
      serviceCategories: [],
      waiveVisitCharge: 0,
      gender: '',
      image: '',
    }
  );
  useEffect(() => {
    if (personalDetails) {
      // console.log("personal details:",personalDetails)
      setProviderPersonalDetails(pre => ({ ...pre, ...personalDetails }))
    }
  }, [personalDetails]);

  const [openMobileNumberChangeModal, setOpenMobileNumberChangeModal] = useState(false);
  const handleModalClose = async () => {
    setOpenMobileNumberChangeModal(false);
    // onClose();
    fetchData();
  }

  const handleEdit = async () => {
    const result = await Swal.fire({
      text: "Do you want to Change Customer Mobile Number now?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Change now!',
      cancelButtonText: 'No, Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showCloseButton: false,
    });
    if (result.isConfirmed) {
      setCustomerVerificationModal('change mobile number')
    } else {
      return false
    }
  }


  return (
    <>
      <Box>
        <Card>
          <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
            <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Personal Info</Typography>
          </Box>
          <Grid container spacing={1} sx={{ p: '1%' }}>
            <Grid item xs={12} sm={6} md={5} lg={4}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Name</Typography>
              <TextField
                sx={{}}
                size='small'
                fullWidth
                disabled
                value={`${personalDetails?.profile?.firstName || ''} ${personalDetails?.profile?.middleName || ''} ${personalDetails?.profile?.lastName || ''}`}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid>
            <Grid item xs={6} md={3} lg={2}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Mobile Number</Typography>
              <TextField
                sx={{}}
                fullWidth
                size='small'
                disabled
                value={personalDetails?.mobileNumber || ''}
                InputProps={{
                  inputProps: {
                    style: { fontSize: '.75rem' }
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <PermissionGuard feature="customer" permission="canEdit">
                        <IconButton size='small' color='warning' onClick={handleEdit}>
                          <Edit sx={{ fontSize: '1rem' }} />
                        </IconButton>
                      </PermissionGuard>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Gender</Typography>
              <TextField
                sx={{}}
                size='small'
                fullWidth
                disabled
                value={personalDetails?.profile?.gender}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid>
            {/* <Grid item xs={12} md={3} >
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Middle Name</Typography>
              <TextField
                sx={{}}
                size='small'
                disabled
                value={personalDetails?.profile?.middleName || ''}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid>
            <Grid item xs={12} md={3} >
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Last Name</Typography>
              <TextField
                sx={{}}
                size='small'
                disabled
                value={personalDetails?.profile?.lastName || ''}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid> */}
            {/* <Grid item xs={12} md={3} /> */}
            <Grid item xs={6} sm={3} md={3} lg={2}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Date of Birth</Typography>
              <TextField
                sx={{}}
                fullWidth
                size='small'
                disabled
                value={personalDetails?.profile?.dob && formatDateTime(personalDetails?.profile?.dob, 'date') || ''}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={9} md={6} lg={4}>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: '600' }}>Email</Typography>
              <TextField
                fullWidth
                sx={{}}
                size='small'
                disabled
                value={personalDetails?.profile?.email || ''}
                inputProps={{
                  style: { fontSize: '.75rem' }
                }}
              />
            </Grid>
          </Grid>
        </Card>
      </Box>
      <Grid item xs={12} >
        <Card sx={{mt:'1%'}}>
          <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
            <Typography sx={{ fontWeight: '600', fontSize: '0.85rem' }}>Address Info</Typography>
          </Box>
          <AddressDetails personalDetails={personalDetails} />
        </Card>
      </Grid>
    </>
  );
}
